import { IAuthenticatedUserInfo, logAndBuildError } from '@notes/webintegrations-common'
import { AuthMethod, IAuthContext } from '../../shared/auth/IAuthContext'
import { IHostIntegration } from '../hostIntegration/IHostIntegration'
import { getSSOTokenFirstParty } from './getAccessTokenInfo'

export class SSOFirstPartyAuthContext implements IAuthContext {
  private accessToken: string
  private substrateNotesToken: string | undefined
  private host: IHostIntegration

  private readonly userInfo: IAuthenticatedUserInfo
  constructor (host: IHostIntegration, initialToken: string,  userInfo: IAuthenticatedUserInfo, substrateNotesToken?: string) {
    this.host = host
    this.accessToken = initialToken
    this.userInfo = userInfo
    this.substrateNotesToken = substrateNotesToken
  }

  getAccessToken(): string {
    return this.accessToken
  }

  getSubstrateNotesToken(): string | undefined {
    return this.substrateNotesToken
  }

  async refresh(): Promise<void> {
    const ssoToken  = await getSSOTokenFirstParty(this.host)
    if (!ssoToken) {
      throw logAndBuildError('Unable to refresh SSO token (first-party)')
    }

    if (ssoToken.userInfo.upn !== this.userInfo.upn) {
      throw logAndBuildError('Unable to refresh SSO token (first-party): account has changed since initial access')
    }

    this.accessToken = ssoToken.authContext.getAccessToken()
    this.substrateNotesToken = ssoToken.authContext.getSubstrateNotesToken()
  }

  getAuthMethod(): AuthMethod {
    return AuthMethod.HostSso
  }
}
